import React, { FC } from 'react';

import type { ColDef } from 'ag-grid-community';

// components
import AGTable from '../../components/ag-table/AGTable';
import styled from 'styled-components';

// theme
import aampeTheme from '../../constants/aampeTheme';
// constants
import ICONS from '../../constants/icons';

// helpers
import { unslugify } from '../../helpers/sanitize.helper';

// models
import {
    ImageDeviceSpecsModel,
    ImageSpecsModel,
} from '../../models/formula.model';

interface FormulaImageSpecsHoverCardProps {
    specs_data: ImageSpecsModel;
}

const FormulaImageSpecsHoverCard: FC<
    React.PropsWithChildren<FormulaImageSpecsHoverCardProps>
> = ({ specs_data }) => {
    const { heading, specs } = specs_data;

    const columnDefs = React.useMemo<ColDef<ImageDeviceSpecsModel>[]>(() => {
        const col = Object.keys(specs).map((c: any) => {
            return {
                headerName: unslugify(c, true),
                field: c,
                sortable: false,
                flex: 1,
                minWidth: c === 'minimum_resolution' ? 200 : undefined,
            };
        });
        return col;
    }, [specs]);
    return (
        <Container>
            <Heading>{heading}</Heading>
            <CategoryWrapper>
                <AGTable
                    columns={columnDefs}
                    rowData={[specs]}
                    customHeaderRowStyle={{
                        backgroundColor: aampeTheme.colors.gray25,
                    }}
                    rowStyle={{
                        border: 'none',
                        minHeight: 50,
                    }}
                    parentContainerStyle={{
                        padding: 0,
                        paddingBottom: aampeTheme.spacing4(4),
                    }}
                />
            </CategoryWrapper>
            <CategoryAlert>
                <Info size={16} />
                <span>
                    For a preview of how the message will be rendered click on
                    “Test a message”
                </span>
            </CategoryAlert>
        </Container>
    );
};

const Container = styled.div({
    padding: aampeTheme.spacing(2),
    backgroundColor: aampeTheme.colors.white,
    display: 'flex',
    flexDirection: 'column',
    border: `1px solid ${aampeTheme.colors.bordersWG01}`,
    borderRadius: 10,
    boxShadow: '0px 32px 64px -12px rgba(16, 24, 40, 0.14);',
    fontWeight: 'normal',
    zIndex: 40000,
    width: 750,
});

const Heading = styled.div({
    fontSize: aampeTheme.size.font.default,
    color: aampeTheme.colors.black,
});

const CategoryWrapper = styled.div({
    display: 'flex',
    flexDirection: 'column',
    marginTop: aampeTheme.spacing(2),
});

const CategoryAlert = styled.div({
    border: `1px solid ${aampeTheme.colors.interactiveA01}`,
    borderRadius: 10,
    color: aampeTheme.colors.solidA01,
    display: 'flex',
    alignItems: 'center',
    gap: aampeTheme.spacing(2),
    padding: aampeTheme.spacing(2),
    fontSize: 16,
    backgroundColor: aampeTheme.colors.primary25,
});

const Info = styled(ICONS.info)(() => ({
    cursor: 'pointer',
    color: aampeTheme.colors.solidA01,
}));

export default FormulaImageSpecsHoverCard;
